export default __webpack_public_path__ + "static/media/Team.7b62bf9b.png";